var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { alertState, curReportState } from "@recoil/assessmentState";
import { loadingBoxState } from "@recoil/menuState";
import { userInfoLoginState } from "@recoil/userState";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { jsopen_AlertPopup } from "@utils/commUtils";
import { API_200, ERROR_MSG, POP_ALERT, TYPE_NONE } from "@utils/Const";
import axios from "axios";
import dayjs from "dayjs";
import JSZip from "jszip";
import { useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
const SharePop = ({ closePopup, getMultiFileUrl, checkItem }) => {
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTreeData = useRecoilValue(curReportState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [errorList, setErrorList] = useState([]);
    const [email, setEmail] = useState("");
    const handleSetEmail = (e) => {
        setErrorList([]);
        setEmail(e.target.value);
    };
    const handleZipDownload = () => __awaiter(void 0, void 0, void 0, function* () {
        let zipList = [];
        let zips = new JSZip();
        let zipCnt = 0;
        const zipFileName = `${recoilTreeData.name}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
        checkItem.map((list) => __awaiter(void 0, void 0, void 0, function* () {
            yield getMultiFileUrl(list)
                .then((val) => {
                if (val.codeNum === 200) {
                    zipList = zipList.concat({
                        fileName: `${list.name}_${dayjs(list.date).format("HH:mm:ss")}.pptx`,
                        fileLink: val.body.proposalFileUrl,
                    });
                }
                return {
                    codeNum: val.codeNum,
                    fileName: `${list.name}_${dayjs(list.date).format("HH:mm:ss")}.pptx`,
                    fileLink: val.body.proposalFileUrl,
                };
            })
                .then((val) => {
                if (val.codeNum === 200) {
                    axios({
                        method: "GET",
                        url: val.fileLink,
                        responseType: "blob",
                    })
                        .then((resp) => {
                        zips.file(val.fileName, resp.data);
                        zipCnt++;
                        return zipCnt;
                    })
                        .then((zipCnt) => {
                        if (zipCnt === checkItem.length) {
                            zips.generateAsync({ type: "blob" }).then(function (blob) {
                                sendEmail(zipFileName, blob); // 파일 공유
                            });
                        }
                    });
                }
            });
        }));
    });
    const sendEmail = (zipFileName, content) => __awaiter(void 0, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        const formData = new FormData();
        const blob = new Blob([JSON.stringify(email)], { type: "application/json" });
        formData.append("email", blob);
        formData.append("file", content, zipFileName);
        yield PromiseHttp({
            httpMethod: "POSTF",
            appPath: `/assessment/report/zip/email`,
            appQuery: formData,
            userToken: userInfo.loginInfo.token,
        }).then((res) => {
            if (res.codeNum == API_200) {
                setAlert(Object.assign(Object.assign({}, alert), { type: TYPE_NONE, divTag: res.body }));
                jsopen_AlertPopup(POP_ALERT);
                closePopup();
            }
            else {
                if (res.errorList) {
                    setErrorList(res.errorList);
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: TYPE_NONE, divTag: res.errorList == null ? ERROR_MSG : res.errorList.map((err) => err.msg) }));
                    jsopen_AlertPopup(POP_ALERT);
                }
            }
        });
        setRecoilIsLoadingBox(false);
    });
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-share", className: "popup-layer js-layer popup-type1 w480" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", Object.assign({ className: "icon-search" }, { children: "\uACF5\uC720" })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePopup }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input w85p" }, { children: _jsxs("li", Object.assign({ className: "center" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "E-Mail" })), _jsxs("div", Object.assign({ className: "input__area w260" }, { children: [_jsx("input", { type: "text", id: "userId0", placeholder: "공유하실 이메일주소를 입력하세요.", className: errorList.filter((err) => err.field === "email").length > 0 ||
                                                errorList.filter((err) => err.field === "mail").length > 0
                                                ? "input-error"
                                                : "", value: email, onChange: (e) => handleSetEmail(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "email").length > 0
                                                ? errorList.filter((err) => err.field === "email").map((err) => err.msg)
                                                : errorList.filter((err) => err.field === "mail").length > 0 &&
                                                    errorList.filter((err) => err.field === "mail").map((err) => err.msg) }))] }))] })) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: closePopup }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: () => handleZipDownload() }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
};
export default SharePop;
